export default {
  en: {
    links: {
      home: 'Home',
      help: 'Request Help',
      faq: 'FAQ'
    }
  }
}
